import { styled } from '@mui/material';
import InviteIcon from '../../illustrations/invite.svg';
import { lightColorPalette } from '@/theme';

export const StyledInviteUserBox = styled('div')`
  display: flex;
  background: ${lightColorPalette.lbWhite};
  padding: 1.8rem;
  border-radius: 2px;
  box-shadow: 0px 0px 34px 0px #3b599833;
  width: 41rem;
  height: 13.5rem;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  gap: 20px;

  &:hover {
    box-shadow: 0px 0px 34px 0px rgba(59, 89, 152, 0.2);
  }
`;

export const StyledInviteUserArea = styled('div')`
  min-width: 25rem;
  max-width: 28rem;
  color: ${lightColorPalette.lbGreyDark};
`;

export const StyledInviteIcon = styled(InviteIcon)`
  cursor: default;
  width: 11rem;
`;

export const StyleButton = styled('button')`
  border: none;
  background: none;
  margin: 0;
  padding: 0 0 0.3rem;
  align-self: start;
  cursor: pointer;
  width: 1rem;
`;
